import type { ReactElement } from "react";
interface UploadMethodToggleProps {
  uploadMethod: "url" | "file";
  onMethodChange: (method: "url" | "file") => void;
}

/**
 * Upload Method Toggle Component
 */
export function UploadMethodToggle({ uploadMethod, onMethodChange }: Readonly<UploadMethodToggleProps>): ReactElement {
  return (
    <div className="flex gap-2">
      <button
        onClick={() => onMethodChange("url")}
        className={`px-2 py-1 text-sm rounded ${uploadMethod === "url" ? "text-lumi-accent" : "text-neutral-400"}`}
      >
        URL
      </button>
      <button
        onClick={() => onMethodChange("file")}
        className={`px-2 py-1 text-sm rounded ${uploadMethod === "file" ? "text-lumi-accent" : "text-neutral-400"}`}
      >
        Upload
      </button>
    </div>
  );
}
